export interface MaskedValueProps {
  value: string;
}

export const MaskedValue = ({ value }: MaskedValueProps) => <>{'•'.repeat(value.length)}</>;
